import { FC, ReactNode } from "react";

export type ChannelSectionProps = {
  title: string;
  children: ReactNode;
};

export const ChannelSection: FC<ChannelSectionProps> = ({
  title,
  children,
}) => (
  <div className="flex flex-col gap-2">
    <span className="font-secondary text-xs leading-2 text-grey">{title}</span>
    <div className="flex flex-col gap-6">{children}</div>
  </div>
);
